import { axiosInstance } from '@/axios'

export default {
  state: {
    classifications: null
  },
  mutations: {
    SET_CLASSIFICATIONS (state, classifications) {
      let newClassifications = classifications
      const primaryClassification = newClassifications.find(c => {
        return c.id === this.state.base.library.primary_classification_key
      })
      newClassifications = newClassifications.filter(c => {
        return c.id !== this.state.base.library.primary_classification_key
      })
      state.classifications = []
      // Set primary Classification as a first item in classifications array
      state.classifications.push(primaryClassification)
      state.classifications.push(...newClassifications)
    }
  },
  actions: {
    getLibraryClassifications ({ commit, rootState }) {
      const librarySlug = rootState.base.library.slug
      return axiosInstance.get('library/' + librarySlug + '/classifications').then((response) => {
        commit('SET_CLASSIFICATIONS', response.data)
      })
    }
  },
  getters: {
    getClassificationByKey: (state) => (key) => {
      return state.classifications?.find(classification => classification.id === parseInt(key)).values
    }
  }
}
